import ShopTheLookTile from '@moncler/components/listing/ShopTheLookTile';
import analytics from '@utils/analytics';
import api from '@utils/api';
import { pagejsonState } from '@utils/appstate';
import { getColorVariations } from '@utils/product';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { Swiper, SwiperSlide } from 'swiper/react';
const ProductRangeCarousel = (props) => {
    const { t } = useTranslation();
    const { noTp, uuid, pageId } = props;
    const [swiperInstance, setSwiperInstance] = useState();
    const [carouselTitle, setCarouselTitle] = useState();
    const [carouselSlides, setCarouselSlides] = useState([]);
    const [activeBullet, setActiveBullet] = useState(0);
    const [products, setProducts] = useState([]);
    const [pageJson] = noTp ? [] : useRecoilState(pagejsonState);
    const elRef = useRef();
    useEffect(() => {
        if (pageJson) {
            const carouselComponent = pageJson.components.find((el) => el.id === props.id);
            const carouselSlides = carouselComponent.regions[0].components;
            const pids = carouselSlides.map((s) => s.data.product);
            api.getProductTiles(pids).then((data) => {
                setCarouselTitle(carouselComponent.data.title);
                setCarouselSlides(carouselSlides);
                setProducts(data);
                fireAnalyticsEvent(data);
            });
        }
    }, [pageJson]);
    useEffect(() => {
        if (noTp) {
            api.getPageJson(pageId, true).then((data) => {
                const carouselComponent = data === null || data === void 0 ? void 0 : data.regions[0].components.find((el) => el.id === uuid);
                const carouselSlides = carouselComponent.regions[0].components;
                const pids = carouselSlides.map((s) => s.data.product);
                api.getProductTiles(pids).then((data) => {
                    setCarouselTitle(carouselComponent.data.title);
                    setCarouselSlides(carouselSlides);
                    setProducts(data);
                });
            });
        }
    }, []);
    const fireAnalyticsEvent = (products) => {
        let firstTime = true;
        const analyticsEventObserverCallback = (entries) => {
            entries.forEach((entry, i) => {
                if (entry.isIntersecting && firstTime) {
                    firstTime = false;
                    analytics.productImpressionsTP(products, pageJson.region.toLowerCase());
                }
            });
        };
        const observer = new IntersectionObserver(analyticsEventObserverCallback, { threshold: 0.1 });
        observer.observe(elRef.current);
    };
    const navigate = (i, color) => {
        setActiveBullet(i);
        swiperInstance.slideTo(i);
        if (color) {
            analytics.techincalPageClick(`grenoble-${pageJson.variationId.substring(0, 17)}`, `color-${color}`);
        }
    };
    return (React.createElement("div", { ref: elRef, className: "container" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-10 offset-1 col-sm-6 offset-sm-3 text-center" },
                React.createElement("h2", { className: "component_product_range_carousel__title" }, carouselTitle)),
            React.createElement("div", { className: "col-12" }, products.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("ul", { className: "component_product_range_carousel__pagination" }, carouselSlides.map((slide, i) => {
                    let product = products.find((p) => p.id === slide.data.product);
                    if (!product) {
                        return;
                    }
                    const currentColor = getColorVariations(product).find((v) => v.selected);
                    return (React.createElement("li", { key: i },
                        React.createElement("button", { "aria-label": product.productName + ' ' + (currentColor === null || currentColor === void 0 ? void 0 : currentColor.displayValue), onClick: () => navigate(i, currentColor === null || currentColor === void 0 ? void 0 : currentColor.displayValue), className: `bullet ${activeBullet === i ? 'active' : ''}` },
                            React.createElement("span", { className: `swatch--${currentColor === null || currentColor === void 0 ? void 0 : currentColor.refinementColor}` }))));
                })),
                React.createElement("div", { className: "swiper-container" },
                    React.createElement(Swiper, { onSwiper: (swipr) => {
                            setSwiperInstance(swipr);
                        }, onActiveIndexChange: (swipr) => {
                            setActiveBullet(swipr.activeIndex);
                        }, mousewheel: {
                            forceToAxis: true,
                            thresholdDelta: 20,
                        }, spaceBetween: 4, slidesPerView: 1, initialSlide: 0, breakpoints: {
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 64,
                            },
                            1200: {
                                slidesPerView: 3,
                                spaceBetween: 146,
                            },
                        }, resizeObserver: true }, carouselSlides.map((slide, i) => {
                        let product = products.find((p) => p.id === slide.data.product);
                        if (!product) {
                            return;
                        }
                        return (React.createElement(SwiperSlide, { key: i },
                            React.createElement("div", { className: "row justify-center" },
                                React.createElement("div", { className: "col-12 col-sm-6 col-md-12" },
                                    React.createElement(ShopTheLookTile, { product: product, index: i, customImage: slide.custom.image, showMobileButton: true, isTechnicalPage: true, region: noTp ? null : pageJson.region })))));
                    })))))))));
};
export default ProductRangeCarousel;
